package com.platforma.chat_domain.di

import com.platforma.chat_domain.ChatsUseCase
import com.platforma.chat_domain.use_case.DraftTableUseCase
import com.platforma.chat_domain.DraftUseCase
import com.platforma.chat_domain.MessagesUseCase
import com.platforma.chat_domain.use_case.chats.TableChatsUseCase
import com.platforma.chat_domain.use_case.message.NetworkMessageUseCase
import com.platforma.chat_domain.use_case.message.TableMessageUseCase
import org.koin.dsl.module

val chatDomainModule = module {
    single {
        DraftUseCase(
            table = DraftTableUseCase(repository = get())
        )
    }

    single {
        MessagesUseCase(
            table = TableMessageUseCase(mokMessagesRepository = get()),
            network = NetworkMessageUseCase(mokMessagesRepository = get())
        )
    }

    single {
        ChatsUseCase(
            table = TableChatsUseCase(chatsRepository = get())
        )
    }
}